import { KomaComponent } from '../page/koma.component';
import { RegistKomaModel } from '../vo/regist-koma.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ情報登録コマンド
 *
 * @export
 * @class RegistKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private koma: KomaComponent = null;
  private vo: RegistKomaModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Koma: {
          parameter: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNum: this.vo.pageNum,
            SectionID: this.vo.sectionID
          },
          condition: {
            PositionX: this.vo.positionX,
            PositionY: this.vo.positionY,
            SizeW: this.vo.sizeW,
            SizeH: this.vo.sizeH
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KomaComponent} koma コマ
   * @param {RegistKomaModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof RegistKomaService
   */
  execute(koma: KomaComponent, vo: RegistKomaModel, successFunction: Function) {
    this.koma = koma;
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14registKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistKomaService
   */
  success(data: any) {
    this.koma.komaId = data.KomaID;
    this.successFunction(this.koma);
  }
}
